export const initialCompanyLogoState = {
  logo: null
};

export interface ICompanyLogoState {
  logo: any
}
